import {AbstractContent} from './abstract-content';

/**
 * Custom bootstrap gallery element.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Gallery extends AbstractContent<null> {
  private imageContainer: HTMLElement;
  private carousel: HTMLElement;
  private readonly thumbnails: NodeListOf<HTMLElement>;

  constructor(container: HTMLElement) {
    super(container);
    const imageContainer = this.container.querySelector<HTMLElement>('.image-container');
    const carousel = this.container.querySelector<HTMLElement>('.carousel');
    if (!imageContainer || !carousel) {
      throw new Error('Required elements missing.');
    }
    this.imageContainer = imageContainer;
    this.carousel = carousel;
    this.thumbnails = this.carousel.querySelectorAll('.thumbnail');
    this.initializeThumbnailNavigation();
  }

  /**
   * Initializes the thumbnail navigation.
   */
  private initializeThumbnailNavigation(): void {
    for (const thumbnail of this.thumbnails) {
      thumbnail.addEventListener('click', () => {
        const activeImage = this.imageContainer.querySelector('.active');
        const nextImage = this.imageContainer.querySelector<HTMLElement>('[data-id="' + thumbnail.dataset.id + '"]');
        if (!activeImage || !nextImage || activeImage === nextImage) {
          return;
        }

        // Transition away old image and show new one
        activeImage.classList.add('hiding');
        setTimeout(() => {
          nextImage.classList.add('showing');
        }, 500);
        setTimeout(() => {
          activeImage.classList.remove('hiding', 'active');
          nextImage.classList.remove('showing');
          nextImage.classList.add('active');
        }, 600);
      });
    }
  }
}
